import { render } from "./OcrSubNav.vue?vue&type=template&id=4cb81d8a"
import script from "./OcrSubNav.vue?vue&type=script&lang=js"
export * from "./OcrSubNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__